<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import i18n from '../../../i18n';
import Swal from "sweetalert2";
import Repositories from "@/repositories";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: i18n.t('general.tracking'),
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loading
  },
  data() {
    return {
      title: i18n.t('general.tracking'),
      items: [
        {
          text: "",
          href: "/" + this.$route.params.organisationcode,
        },
        {
          text: "",
          active: true,
        },
      ],
      trackingnumber: null,
      formSubmit: false,
      isLoading: false,
      repository: null
    };
  },
  created() {
    this.repository = Repositories.get("workorders", this.$route.params.organisationcode);
  },
  methods: {
    search() {
      this.isLoading = true;
      this.repository.actions.exist(this.trackingnumber).then((response) => {
        if (response.data === true) {
          this.$router.push({
            path: this.$route.params.organisationcode + "/" + this.trackingnumber
          });
        } else {
          Swal.fire("", this.$t("general.noprojectfound"), "warning").then(() => {
            this.trackingnumber = null;
          });
        }
      }, (error) => {
        Swal.fire("", error.message, "warning").then(() => {
          this.trackingnumber = null;
        });
        window.console.error(error);
      })
        .finally(() => {
          this.isLoading = false
        });
    }
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <loading :active.sync="isLoading" :can-cancel="false" color='#f1b44c' :width=70 :height=70 loader='dots'
      :is-full-page="true">
    </loading>
    <div style="height:70vh;">
      <h4> {{ $t("search.description") }}
      </h4>
      <div class="row">
        <div class="col-lg-4">
          <input type="text" name="" v-model="trackingnumber" class="form-control" />
          <div v-if="formSubmit && $v.form.trackingnumber.$error" class="invalid-feedback">
            <span v-if="!$v.form.fname.required">{{ $t("general.required") }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <button type="button" @click="search" class="btn btn-primary btn-search">{{ $t("general.track") }}</button>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.btn-search {
  margin-top: 20px;
  margin-left: 15px;
}
</style>